import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import TabsAnexos from './components/TabsAnexos';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const AnexosMain = () => {
  const [activeTab, setActiveTab] = useState('upload');

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[{ name: 'Inicio' }, { name: 'Anexos' }]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <TabsAnexos activeTab={activeTab} setActiveTab={setActiveTab} />
        </Col>
      </Row>
    </Container>
  );
};

export default AnexosMain;
